import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '@store/hooks';

/**
 * After cookie session bootstrap, normalize Microsoft SSO return URLs:
 * - `sso_error` → send user to `/login` so existing alerts can render.
 * - `sso=1` success → strip query noise while staying on the current path (e.g. `/`).
 */
export function SsoQueryCleanup() {
  const location = useLocation();
  const navigate = useNavigate();
  const sessionBootstrapComplete = useAppSelector((s) => s.auth.sessionBootstrapComplete);

  useEffect(() => {
    if (!sessionBootstrapComplete) return;
    const params = new URLSearchParams(location.search);
    const err = params.get('sso_error');
    if (err && location.pathname !== '/login') {
      navigate({ pathname: '/login', search: location.search }, { replace: true });
      return;
    }
    if (params.has('sso')) {
      params.delete('sso');
      const qs = params.toString();
      navigate({ pathname: location.pathname, search: qs ? `?${qs}` : '' }, { replace: true });
    }
  }, [sessionBootstrapComplete, location.pathname, location.search, navigate]);

  return null;
}
